import { render, staticRenderFns } from "./ArtistsInLine.vue?vue&type=template&id=6b13d4cd&scoped=true&"
import script from "./ArtistsInLine.vue?vue&type=script&lang=js&"
export * from "./ArtistsInLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b13d4cd",
  null
  
)

export default component.exports